<template lang="pug">
  .max-w-320.mx-auto.mx-lg-0
    h4.mb-2 Welcome
    p.mb-5 {{ infoText }}
    .alert.alert-danger(v-if="hasError")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  {{ errorMessage }}

    el-form(
     status-icon
     ref="resetPassword"
     @submit.native.prevent="validateForm('resetPassword')"
    )
      el-form-item(prop="password").mb-4
        el-input(v-model="password" type="password" placeHolder="password")
      el-form-item(prop="confirmPassword").mb-4
        el-input(v-model="confirmPassword" type="password" placeHolder="confirmPassword")
      el-form-item
       el-button(type="primary" :loading="loading" @click="cognitoResetPassword")
         | Confirm Password

</template>

<script>
// import UserLogin from '@/helpers/userlogin';
// import User from '@/models/user';
import { getInitPassword, syncUpUser } from '@/models/user';
import { AmplifyEventBus } from 'aws-amplify-vue';

export default {
  name: 'ConfirmCode',
  data() {
    return {
      accountConfirmed: false,
      password: '',
      confirmPassword: '',
      infoText: 'Cofirming code',
      cognitoUser: null,
      loading: false,
      userName: null,
      userDetails: null,
      hasError: false,
      tempPassword: '',
    };
  },

  mounted() {
    this.initComp();
  },

  methods: {
    initComp() {
      const { data, code } = this.$route.query;
      if (!data || !code) {
        this.goToAuth();
      }
      const decoded = JSON.parse(atob(data));
      this.userName = decoded.userName;
      this.$Amplify.Auth.confirmSignUp(decoded.userName, code)
        .then((da) => {
          console.log(da);
          this.accountConfirmed = true;
          this.loginAndResetPassword(decoded.email);
        }).catch((err) => {
          if (err.code === 'NotAuthorizedException'
              || err.code === 'LimitExceededException') {
            this.loginAndResetPassword(decoded.email);
          }
        })
        .finally(() => {
          console.log('finally');
        });
    },

    goToAuth() {
      this.$router.push('/sign-in');
    },

    async loginAndResetPassword(email) {
      this.tempPassword = await getInitPassword(email);
      console.log(email);
      console.log(this.tempPassword);
      this.$Amplify.Auth.signIn(email, this.tempPassword)
        .then((user) => {
          this.cognitoUser = user;
          this.accountConfirmed = true;
          if (this.cognitoUser.attributes['custom:signup'] === 'init') {
            return syncUpUser(this.cognitoUser);
          }
          return Promise.resolve({});
        }).then((udata) => {
          console.log(udata);
          this.infoText = 'Please Rest your password';
        }).catch((err) => {
          console.log(err);
          this.goToAuth();
        });
    },

    cognitoResetPassword() {
      this.loading = true;
      this.$Amplify.Auth.changePassword(this.cognitoUser, this.tempPassword, this.password)
        .then((data) => {
          console.log(data);
          AmplifyEventBus.$emit('authState', 'signedIn');
          this.$router.push('/');
        }).catch((err) => {
          console.log(err);
          this.goToAuth();
        })
        .finally(() => {
          this.loading = false;
        });
    },

  },
};
</script>
